<template>
  <div class="routePlanning" id="routePlanning" style="width: 100%; height: 100%">
    <div
      id="routePlanningMap"
      style="width: 100%; height: 100%"
      ref="routePlanningMap"
    ></div>
    <div class="left" v-show="!modifyFlag">
      <div class="rows">
        <div class="title">编号：</div>
        <div class="no">{{ local_id }}</div>
      </div>
      <div class="rows">
        <div class="desc">创建时间：</div>
        <div class="desc">{{ createTime }}</div>
        <div class="descTitle">航线长度：</div>
        <div class="desc desc2">{{ totalLength }}KM</div>
        <div class="descTitle descTitle2">起点：</div>
        <tooltip-over
          :content="starStayPointName"
          :className="'content'"
          class="wid190"
          refName="starStayPointName"
        ></tooltip-over>
        <div class="descTitle">终点：</div>
        <tooltip-over
          :content="endStayPointName"
          :className="'content'"
          class="wid190"
          refName="endStayPointName"
          style="width: 105px"
        ></tooltip-over>
      </div>
      <el-table
        ref="routeList"
        :data="routeList"
        height="170"
        style="width: 94%"
        :row-style="{ height: '40px' }"
        :cell-style="{ padding: '0' }"
        :row-class-name="tableRowClassName"
        tooltip-effect="light"
        class="taskTable"
      >
        <el-table-column
          prop="index"
          label="航点"
          align="center"
          width="50"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="lon"
          label="经度"
          align="center"
          min-width="80"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="lat"
          label="纬度"
          align="center"
          min-width="75"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="rAlt"
          label="海拔高度"
          align="center"
          min-width="80"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-input
              v-model.number="scope.row.rAlt"
              class="inputColumn"
              maxlength="5"
              oninput="value=value.replace(/[^0-9]/g,'')"
              @blur="blurInput(scope.row, 'rAlt')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="alt"
          label="飞行高度"
          align="center"
          min-width="80"
          :show-overflow-tooltip="true"
          ><template slot-scope="scope">
            <el-input
              v-model.number="scope.row.alt"
              class="inputColumn"
              maxlength="5"
              oninput="value=value.replace(/[^0-9]/g,'')"
              @blur="blurInput(scope.row, 'alt')"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="command"
          label="附加指令"
          align="center"
          min-width="60"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="60" v-if="routeList ? routeList.length > 2 : false">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.index != 1 && scope.row.index != routeList.length"
              @click="delPoint(scope.row.index)"
              type="text"
              class="delBtn"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="rows" style="margin-top: 8px">
        <div class="titleDes">当前经度：</div>
        <div class="titleContent">{{ currentLon }}</div>
        <div class="titleDes">纬度：</div>
        <div class="titleContent">{{ currentLat }}</div>
        <div class="buttondes" @click="addTrackPoint">
          <div class="el-icon-add-img"></div>
          添加航点
        </div>

        <div class="buttondes" @click="uploadAirline">
          <div class="el-icon-upload-img"></div>
          上传航线
        </div>

        <div class="buttondes" @click="modifyFly">
          <div class="el-icon-replay-img"></div>
          飞行回放
        </div>

        <div class="buttondes" @click="modifyFly">
          <div class="el-icon-simulation-img"></div>
          模拟推演
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :close-on-click-modal="false"
      :visible.sync="addTrackPointShow"
      :append-to-body="true"
      @close="closeHeightSet"
      custom-class="heightSetDialogContainer"
      width="271px"
    >
      <div class="heightSetContainer">
        <div class="header">
          <div class="headerInfo">
            <label>预设飞行高度</label>
            <i class="el-icon-close" @click="closeHeightSet"></i>
          </div>
          <div class="separator"></div>
        </div>
        <div class="main">
          <el-select
            v-model="heightType"
            class="routePlanningSelect"
            popper-class="selectPopperClass"
          >
            <el-option value="rAlt" label="相对高"></el-option>
            <el-option value="alt" label="海拔高"></el-option>
          </el-select>
          <div class="heightOptContainer">
            <el-button
              class="add btn"
              icon="el-icon-plus"
              @click="addDefaultHeight"
            ></el-button>
            <el-input
              v-model="defaultHeight"
              maxlength="5"
              oninput="value=value.replace(/[^\d]/g,'')"
            ></el-input>
            <el-button
              class="reduce btn"
              icon="el-icon-minus"
              @click="reduceDefaultHeight"
            ></el-button>
          </div>
        </div>
        <div class="footer">
          <div class="btn" @click="addTrackPointEvent">确定</div>
          <div class="btn" @click="closeHeightSet">取消</div>
        </div>
      </div></el-dialog
    >

    <!-- 地图模式调整 -->
    <MapStyle @changeMapStyle="changeMapStyle"></MapStyle>
    <RoutePlanningEchart
      :routeList="routeList"
      ref="routePlanningEchart"
      v-show="!modifyFlag"
    ></RoutePlanningEchart>
    <!-- 航路规划面板 -->
    <RoutePlanningPanel
      :userInfo="userInfo"
      :starStayPointId="starStayPointId"
      :endStayPointId="endStayPointId"
      @changeRoutePlanning="changeRoutePlanning"
      @showAirspace="showAirspace"
      @requestNewAirline="requestNewAirline"
      @showNewAirline="showNewAirline"
      ref="routePlanningPanel"
      v-show="!modifyFlag"
    ></RoutePlanningPanel>
    <RoutePlanningPlay
      :isModifyPlay="isModifyPlay"
      @changeMultiple="changeMultiple"
      @changeModifyPlay="changeModifyPlay"
      @resetFly="resetFly"
      v-show="modifyFlag"
    ></RoutePlanningPlay>
    <RoutePlanningReport
      :local_id="local_id"
      :createTime="createTime"
      :routeList="routeList"
      :showModifyReport="showModifyReport"
      :totalLength="totalLength"
      :starStayPointName="starStayPointName"
      :endStayPointName="endStayPointName"
      @changeModifyReportStatus="changeModifyReportStatus"
      v-show="modifyFlag && showModifyReport"
    ></RoutePlanningReport>
    <RoutePlanningResult
      :uploadSuccess="uploadSuccess"
      :showResult="showResult"
      @changeResultStatus="changeResultStatus"
    ></RoutePlanningResult>
    <RoutePlanningNameSet
      :showNameSet="showNameSet"
      @changeNameSetStatus="changeNameSetStatus"
      @doUploadAirline="doUploadAirline"
      ref="routePlanningNameSet"
    ></RoutePlanningNameSet>
  </div>
</template>

<script type="text/javascript">
import {
  initMap,
  addLine,
  addPoint,
  removePoint,
  changeMapStyle,
  addEventListener,
  removeEventListener,
} from "../../../assets/js/map/OlMapUtil";
import airspaceStyle from "../../../assets/js/map/airspaceStyle";
import MapStyle from "../../mapContent/MapStyle";
import RoutePlanningEchart from "./RoutePlanningEchart";
import RoutePlanningPanel from "./RoutePlanningPanel";
import RoutePlanningPlay from "./RoutePlanningPlay";
import RoutePlanningReport from "./RoutePlanningReport";
import RoutePlanningResult from "./RoutePlanningResult";
import RoutePlanningNameSet from "./RoutePlanningNameSet";
import * as olProj from "ol/proj";
import * as olSphere from "ol/sphere";
import DoubleClickZoom from "ol/interaction/DoubleClickZoom";
import { wgs84ToGcj02, gcj02ToWgs84 } from "../../../assets/js/map/ConverseLngAndLa";

import tooltipOver from "../../tools/tooltipOver";
export default {
  name: "RoutePlanning",
  props: ["userInfo", 'startEndPlanPointTableData'],
  data() {
    return {
      routePlanningMap: null,
      center: [104.06, 30.67],
      mapType: "hybrid", //地图类型([normal:街道图;hybrid:卫星图])
      routeList: [], //航路列表
      polyLineId: 1, //航线id
      routeLayer: null, //ol航路层
      pointIds: [], //点id列表
      currentLon: null, //当前经度
      currentLat: null, //当前纬度
      mapInitZoom: 10, //地图初始化缩放层级
      addTrackPointShow: false, //添加航点高度设置控制
      heightType: "rAlt", //当前的高度类型
      defaultHeight: 100, //当前的默认高度
      addTrackStart: false, //当前是否在添加航点事件标志
      tempPoints: [], //保存临时航点信息
      local_id: "",
      createTime: "",
      totalLength: 0, //航线总距离
      starStayPointName: "",
      starStayPointId: "",
      endStayPointName: "",
      endStayPointId: "",
      modifyFlag: false, //当前是否在模拟推演
      modifyData: {
        speed: 240, //120KM
        multiple: 100, //倍数
        routeList: [],
        currentIndex: 0, //当前正在回放的点
        currentCount: 0,
        totalCount: 0,
        time: 100, //推演时间间隔
        flightId: 1000000,
      }, //模拟信息
      isModifyPlay: false, //当前是否在播放
      showModifyReport: false,
      uploadSuccess: false, //航路提交是否成功
      showResult: false, //是否显示提交结果
      showNameSet: false,
    };
  },
  methods: {
    init(id, routeId) {
      this.$data.createTime = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      this.initMap();
      this.cleanData(); //清除原有的数据
      if (!this.isEmptyStr(routeId)) {
        this.doInit(id); //请求数据并显示
        this.doInitAirline(routeId);
      } else {
        // this.doInit(id); //请求数据并显示
        this.routeList = []
        this.startEndPlanPointTableData.forEach((item, i) => {
            this.routeList[i] = {
              lon : item.longitude,
              lat : item.latitude,
              rAlt : item.altitude,
              id : item.id,
              name : item.name,
              temp : item.temp,
              type : item.type
            }
        })
      }
    },
    initMap() {
      this.disposeMap(); //先清除map
      let routePlanningMap = initMap("routePlanningMap", this.center, this.mapType, null);
      this.routePlanningMap = routePlanningMap;
      window.TEMP_Route_OLMAP = routePlanningMap;
      this.removeDefaultDblClick();
      this.initMapEvent();
    },
    //清除原有的数据
    cleanData() {
      this.$data.routeList = []; //重新设置航路列表
      this.$data.tempPoints = [];
      this.$data.local_id = "";
    }, //请求数据并显示
    doInit(id) {
      this.getRequest("/uav-task-server/flight/queryFlight.do?id=" + id).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          const taskPlan = (this.$data.taskPlan = oData.data);
          this.initStayPointPolyline(taskPlan);
          this.mergeAirlinePoint();
          this.initDrawPosition(); //初始化绘制位置
        } else if (oData.code != 401) {
        }
      });
    },
    doInitAirline(id) {
      this.getRequest("/uav-task-server/airline/getAirLineById.do?id=" + id).then(
        (res) => {
          let oData = res.data;
          if (oData.code === 0) {
            if (oData.data && oData.data.task_coordinate_waypoints) {
              console.log(oData.data.task_coordinate_waypoints)
              const waypoints = oData.data.task_coordinate_waypoints.split(";");
              // const points = (this.$data.tempAirlinePoints = []);
              const points = [];
              waypoints.forEach((point) => {
                const pointArr = point.split(",");
                points.push({
                  lon: parseFloat(parseFloat(pointArr[1]).toFixed(6)),
                  lat: parseFloat(parseFloat(pointArr[2]).toFixed(6)),
                  alt: parseFloat(pointArr[4]),
                  rAlt: parseFloat(pointArr[3]),
                  command: "航点",
                });
              });
              this.routeList = points
              this.$data.local_id = oData.data.local_id; //设置航线local_id
              this.$data.currentAirline = oData.data;
              this.mergeAirlinePoint();
              this.$message({
                message: "获取航线成功",
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
                onClose: function () {},
              });
            }
          } else if (oData.code != 401) {
            this.$message({
              message: "获取航线失败",
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {},
            });
          }
        }
      );
    },
    mergeAirlinePoint() {
      const routeList = this.$data.routeList;
      const tempAirlinePoints = this.$data.tempAirlinePoints;
      if (!this.isEmptyArray(routeList) && !this.isEmptyArray(tempAirlinePoints)) {
        let newRouteList = [routeList[0]];
        newRouteList = newRouteList.concat(tempAirlinePoints);
        newRouteList.push(routeList[routeList.length - 1]);
        this.$data.routeList = newRouteList;
        this.$data.tempAirlinePoints = null;
      }
      this.showPolyline();
    },
    //初始化绘制位置
    initDrawPosition() {
      const routeList = this.$data.routeList;
      if (!this.isEmptyArray(routeList)) {
        const start = routeList[0];
        const end = routeList[routeList.length - 1];
        const center = [(start.lon + end.lon) / 2, (start.lat + end.lat) / 2];
        this.routePlanningMap
          .getView()
          .setCenter(this.toMercatorPoint(center[0], center[1]));
        this.routePlanningMap.getView().setZoom(this.$data.mapInitZoom);
      }
    },
    initStayPointPolyline(taskPlan) {
      const routeList = this.$data.routeList;
      if (taskPlan.starstaypoint) {
        const starstaypoint = taskPlan.starstaypoint;
        if (starstaypoint.longitude && starstaypoint.latitude) {
          routeList.push({
            local_id: this.$data.local_id,
            lon: starstaypoint.longitude,
            lat: starstaypoint.latitude,
            alt: starstaypoint.altitude,
            rAlt: starstaypoint.altitude,
            command: "起飞",
          });
        }
        this.$data.starStayPointName = starstaypoint.name;
        this.$data.starStayPointId = starstaypoint.id;
      }
      if (taskPlan.endstaypoint) {
        const endstaypoint = taskPlan.endstaypoint;
        if (endstaypoint.longitude && endstaypoint.latitude) {
          routeList.push({
            local_id: this.$data.local_id,
            lon: endstaypoint.longitude,
            lat: endstaypoint.latitude,
            alt: endstaypoint.altitude,
            rAlt: endstaypoint.altitude,
            command: "降落",
          });
        }
        this.$data.endStayPointName = endstaypoint.name;
        this.$data.endStayPointId = endstaypoint.id;
      }
      this.$nextTick(function () {
        this.$refs.routePlanningPanel.queryTask();
      });
    }, //显示航线
    showPolyline() {
      const points = [];
      const routePoints = [];
      const routeList = this.$data.routeList;
      const routePlanningMap = this.$data.routePlanningMap;
      const pointIds = this.$data.pointIds;
      const newPointIds = (this.$data.pointIds = []);
      let routeLayer = this.$data.routeLayer;
      const polyLineId = this.$data.polyLineId;
      if (!this.isEmptyArray(routeList)) {
        for (let index = 0; index < routeList.length; index++) {
          const point = routeList[index];
          routePoints.push(this.toMercatorPoint(point.lon, point.lat));
          points.push({
            id: index,
            longtitude: point.lon,
            latitude: point.lat,
          });
          newPointIds.push(index);
        }
      }
      //移除航点和航迹
      if (!this.isEmptyArray(pointIds)) {
        removePoint(routePlanningMap, pointIds);
      }
      if (null != routeLayer) {
        routePlanningMap.removeLayer(routeLayer);
        routeLayer = null;
      }
      //绘制航点和航迹
      if (null == routeLayer) {
        this.$data.routeLayer = addLine(
          routePlanningMap,
          { id: polyLineId },
          routePoints,
          airspaceStyle.taskPlanRouteStyle
        );
      }
      if (!this.isEmptyArray(points)) {
        addPoint(routePlanningMap, points, airspaceStyle.taskPlanRoutePointStyle);
      }
      this.afterShowPolyline();
    },
    afterShowPolyline() {
      const routeList = this.$data.routeList;
      if (!this.isEmptyArray(routeList)) {
        let length = 0;
        for (let index = 1; index < routeList.length; index++) {
          const element0 = routeList[index - 1];
          const element1 = routeList[index];
          length += olSphere.getDistance(
            [element0.lon, element0.lat],
            [element1.lon, element1.lat]
          );
        }
        this.$data.totalLength = (length / 1000).toFixed(2);
      }
    }, //Google坐标转换为墨卡托坐标
    toMercatorPoint(lng, lat) {
      let coordinate = wgs84ToGcj02(lng, lat); //wgs84 经纬度处理
      return olProj.fromLonLat(coordinate); //转换后的经纬度转WEB墨卡托坐标
    }, //墨卡托转wgs84坐标
    mctToWgs84(lng, lat) {
      return olProj.transform([lng, lat], "EPSG:3857", "EPSG:4326");
    },
    //修改地图显示样式
    changeMapStyle: function (mapType) {
      this.mapType = mapType;
      changeMapStyle(mapType, this.routePlanningMap);
    },
    tableRowClassName({ row, rowIndex }) {
      return "rowStyle";
    },
    //显示空域
    showAirspace(data) {
      this.defaultShowAirspace(this.routePlanningMap, data);
    }, //移除ol默认双击事件
    removeDefaultDblClick() {
      const routePlanningMap = this.routePlanningMap;
      // 删除默认的双击事件
      const dblClickInteraction = routePlanningMap
        .getInteractions()
        .getArray()
        .find((interaction) => {
          return interaction instanceof DoubleClickZoom;
        });
      routePlanningMap.removeInteraction(dblClickInteraction);
    }, //地图事件初始化
    initMapEvent() {
      this.routePlanningMap.on("pointermove", this.olMapPointerMoveEvent);
    }, //鼠标移动事件
    olMapPointerMoveEvent(event) {
      this.setMouseRealTimePoint(event);
    }, //设置鼠标实时坐标
    setMouseRealTimePoint(event) {
      const mctPoint = event.coordinate;
      const point = this.mctToWgs84(mctPoint[0], mctPoint[1]);
      this.$set(this.$data, "currentLon", point[0].toFixed(6));
      this.$set(this.$data, "currentLat", point[1].toFixed(6));
    }, //添加航点事件
    addTrackPointEvent() {
      if (!this.checkHeight()) {
        this.$confirm("<i class='el-icon-warn-tip'></i>请输入高度", "提示", {
          confirmButtonText: "好的",
          customClass: "confirmClass-style",
          iconClass: "",
          confirmButtonClass: "confirm",
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          cancelButtonClass: "cancel",
        });
      } else {
        this.$data.addTrackPointShow = false;
        this.$data.addTrackStart = true; //设置添加航点标志
        const routePlanningMap = this.routePlanningMap;
        routePlanningMap.un("singleclick", this.singleClickMapEvent);
        routePlanningMap.on("singleclick", this.singleClickMapEvent);
        routePlanningMap.un("dblclick", this.dblClickMapEvent);
        routePlanningMap.on("dblclick", this.dblClickMapEvent);
        this.resetTempPoints();
      }
    }, //重置缓存航点信息
    resetTempPoints() {
      const routeList = this.$data.routeList;
      if (!this.isEmptyArray(routeList) && 2 < routeList.length) {
        const tempPoints = (this.$data.tempPoints = []);
        for (let index = 1; index < routeList.length - 1; index++) {
          tempPoints.push(routeList[index]);
        }
      }
    },
    resetStartEndHeight() {
      let routeList = this.$data.routeList;
      const tempPoints = this.$data.tempPoints;
      const defaultHeight = this.$data.defaultHeight;
      let newRouteList = [routeList[0]];
      newRouteList = newRouteList.concat(tempPoints);
      newRouteList.push(routeList[routeList.length - 1]);
      if (!this.isEmptyArray(newRouteList)) {
        newRouteList.forEach((e) => {
          // e.rAlt = defaultHeight;
          // e.alt = defaultHeight;
        });
      }
      this.$data.routeList = newRouteList;
    },
    singleClickMapEvent(event) {
      if (this.$data.addTrackStart) {
        const tempPoints = this.$data.tempPoints;
        const defaultHeight = this.$data.defaultHeight;
        const mctPoint = event.coordinate;
        const point = this.mctToWgs84(mctPoint[0], mctPoint[1]);
        tempPoints.push({
          local_id: this.$data.local_id,
          lon: parseFloat(point[0].toFixed(6)),
          lat: parseFloat(point[1].toFixed(6)),
          alt: defaultHeight,
          rAlt: defaultHeight,
          command: "航点",
        });
        this.resetStartEndHeight();
        this.showPolyline();
      }
    },
    dblClickMapEvent() {
      if (this.$data.addTrackStart) {
        this.$data.addTrackStart = false; //结束添加航点事件
        this.resetStartEndHeight();
        this.showPolyline();
      }
    },
    requestNewAirline() {
      if (this.$data.isModifyPlay) {
        this.resetFly();
      }
      this.$data.tempPoints = [];
      this.$data.addTrackStart = false; //结束添加航点事件
      this.resetStartEndHeight();
      this.showPolyline();
      this.$data.requestNewAirlineFlag = true; //设置当前正在请求航线数据
    },
    showNewAirline(points) {
      const tempPoints = (this.$data.tempPoints = []);
      if (!this.isEmptyArray(points)) {
        points.forEach((point) => {
          tempPoints.push({
            local_id: this.$data.local_id,
            lon: point.lon,
            lat: point.lat,
            alt: this.$data.defaultHeight,
            rAlt: this.$data.defaultHeight,
            command: "航点",
          });
        });
      }
      this.$data.addTrackStart = false; //结束添加航点事件
      this.resetStartEndHeight();
      this.showPolyline();
      this.$data.requestNewAirlineFlag = false; //设置航线请求完毕
    },
    //检查高度
    checkHeight() {
      const height = this.$data.defaultHeight;
      if (null == height) {
        return false;
      }
      return true;
    },
    addTrackPoint() {
      this.$data.addTrackPointShow = true;
    },
    delPoint(index) {
      this.$data.routeList.splice(index - 1, 1);
      if (this.$data.addTrackStart) {
        this.$data.tempPoints.splice(index - 2, 1);
      }
      this.showPolyline();
    },
    closeHeightSet() {
      this.$data.addTrackPointShow = false;
    },
    addDefaultHeight() {
      this.addOrReduceDefaultHeight(true);
    },
    reduceDefaultHeight() {
      this.addOrReduceDefaultHeight(false);
    },
    addOrReduceDefaultHeight(add) {
      const min = 0;
      const max = 99999;
      let data = 0;
      if (this.$data.defaultHeight && parseInt(this.$data.defaultHeight)) {
        data = parseInt(this.$data.defaultHeight);
      }
      if (add) {
        data += 1;
      } else {
        data -= 1;
      }
      if (min <= data && data <= max) {
      } else if (
        (!this.$data.defaultHeight || isNaN(this.$data.defaultHeight)) &&
        !add &&
        data < min
      ) {
        data = min;
      } else if (max < data) {
        data = max;
      } else if (data < min) {
        data = min;
      }
      if (data || 0 == data) {
        data = String(data);
        this.$set(this.$data, "defaultHeight", data);
      }
    },
    changeRoutePlanning(flag) {
      this.$emit("changeIsRoutePlanning", flag);
    },
    disposeMap() {
      if (!this.routePlanningMap) {
        return;
      }
      removeEventListener(this.routePlanningMap);
      // 清除地图信息
      if (window.TEMP_Route_OLMAP) {
        window.TEMP_Route_OLMAP.dispose();
        window.TEMP_Route_OLMAP = null;
      }
    }, //模拟飞行
    modifyFly() {
      this.$data.modifyFlag = true;
      const routeList = this.$data.routeList;
      this.$data.modifyData.routeList = routeList;
      this.$data.modifyData.currentIndex = 0;
      this.$data.modifyData.currentCount = 0;
      this.$data.modifyData.totalCount = 0;
      this.showUav({
        id: this.$data.modifyData.flightId,
        longtitude: routeList[0].lon,
        latitude: routeList[0].lat,
      });
    },
    changeMultiple(count) {
      if (this.$data.modifyPlayTimer) {
        clearTimeout(this.$data.modifyPlayTimer);
      }
      const modifyData = this.$data.modifyData;
      modifyData.multiple += count;
      if (modifyData.multiple < 1) {
        modifyData.multiple = 1;
      }
      //如果当前未飞行,则直接返回
      if (!this.$data.isModifyPlay) {
        return;
      }
      modifyData.currentIndex--;
      const lon = modifyData.lon * modifyData.currentCount;
      const lat = modifyData.lat * modifyData.currentCount;
      const flag = modifyData.currentCount == modifyData.totalCount ? false : true;
      this.reCalcData();
      if (flag) {
        0 == modifyData.lon
          ? this.reSetCurrentCount(lat, modifyData.lat)
          : this.reSetCurrentCount(lon, modifyData.lon);
      }
      this.testModifyFly(); //启动模拟
    },
    reSetCurrentCount(lonLength, length) {
      const modifyData = this.$data.modifyData;
      const count = Math.ceil(lonLength / length);
      modifyData.currentCount = count;
    },
    changeModifyPlay(play) {
      //检查航线的请求状态,如果正在请求航线数据,则返回
      if (!this.checkAirlineStatus()) {
        return;
      }

      this.$data.isModifyPlay = play;
      if (play) {
        this.$data.modifyData.currentCount--;
        if (this.$data.modifyData.currentCount < 0) {
          this.$data.modifyData.currentCount = 0;
        }
        this.testModifyFly();
      } else {
        clearTimeout(this.$data.modifyPlayTimer);
      }
    }, //检查航线的请求状态,如果正在请求航线数据,则返回false
    checkAirlineStatus() {
      if (this.$data.requestNewAirlineFlag) {
        this.$message({
          message: "正在获取航线数据,请稍后",
          duration: 1000,
          customClass: "message-warn-s",
          iconClass: "el-icon-warn-tip",
          offset: 470,
          onClose: function () {},
        });
        return false;
      }
      return true;
    },
    testModifyFly() {
      const modifyData = this.$data.modifyData;
      if (modifyData.currentCount == modifyData.totalCount && !this.reCalcData()) {
        //当前点走完,需要重新计算数据
        return;
      }
      const point0 = modifyData.routeList[modifyData.currentIndex - 1];
      modifyData.currentCount++;
      const point = [
        point0.lon + modifyData.currentCount * modifyData.lon,
        point0.lat + modifyData.currentCount * modifyData.lat,
      ];
      this.showUav({
        id: modifyData.flightId,
        longtitude: point[0],
        latitude: point[1],
      });
      this.$data.modifyPlayTimer = setTimeout(this.testModifyFly, modifyData.time);
    },
    showInitUav() {
      const modifyData = this.$data.modifyData;
      const routeList = this.$data.routeList;
      modifyData.routeList = routeList;
      this.showUav({
        id: modifyData.flightId,
        longtitude: routeList[0].lon,
        latitude: routeList[0].lat,
      });
    }, //移除飞机
    removeUav() {
      removePoint(this.routePlanningMap, [this.$data.modifyData.flightId]);
    },
    showUav(point) {
      const modifyData = this.$data.modifyData;
      removePoint(this.routePlanningMap, [modifyData.flightId]);
      addPoint(this.routePlanningMap, [point], airspaceStyle.uavStyle);
    },
    reCalcData() {
      const modifyData = this.$data.modifyData;
      //如果已经是最后一个点,则退出推演
      if (modifyData.currentIndex == modifyData.routeList.length - 1) {
        this.$set(this.$data, "showModifyReport", true);
        this.endFly();
        return false;
      }
      modifyData.currentIndex++;
      const point0 = modifyData.routeList[modifyData.currentIndex - 1];
      const point1 = modifyData.routeList[modifyData.currentIndex];
      let length = olSphere.getDistance(
        [point0.lon, point0.lat],
        [point1.lon, point1.lat]
      );
      let counter = Math.floor(
        (length / 1000 / modifyData.speed / modifyData.multiple) * 3600
      );
      //至少保证在两个运行点之间移动一次
      if (counter <= 0) {
        counter = 1;
      }
      modifyData.lon = (point1.lon - point0.lon) / counter;
      modifyData.lat = (point1.lat - point0.lat) / counter;
      modifyData.totalCount = counter;
      modifyData.currentCount = 0;
      return true;
    },
    resetFly() {
      //清除定时
      if (this.$data.modifyPlayTimer) {
        clearTimeout(this.$data.modifyPlayTimer);
      }
      this.$data.modifyFlag = false;
      this.endFly();
      this.removeUav(); //设置飞机图标到初始位置
    }, //结束飞行
    endFly() {
      this.$data.isModifyPlay = false; //已结束飞行
      const modifyData = this.$data.modifyData;
      modifyData.currentIndex = 0; //当前正在回放的点
      modifyData.currentCount = 0;
      modifyData.totalCount = 0;
    },
    changeModifyReportStatus(show) {
      this.$set(this.$data, "showModifyReport", show);
    },
    changeResultStatus(show) {
      this.$set(this.$data, "showResult", show);
    },
    changeNameSetStatus(show) {
      this.$set(this.$data, "showNameSet", show);
    },
    uploadAirline() {
      if (this.$data.routeList.length <= 2) {
        this.$message({
          message: "请先添加航点",
          duration: 1000,
          customClass: "message-warn-s",
          iconClass: "el-icon-warn-tip",
          offset: 470,
          onClose: function () {},
        });
        return;
      }
      //回显航线名称
      if (this.$data.currentAirline) {
        this.$refs.routePlanningNameSet.setName(this.$data.currentAirline.name);
      }
      this.$data.showNameSet = true;
    },
    doUploadAirline(name) {
      this.$data.showNameSet = false; //关闭航线设置弹窗
      const airline = this.getAirlineObj(name);
      let url = this.$data.currentAirline
        ? "/uav-task-server/airline/updateAirLine.do"
        : "/uav-task-server/airline/addAirLine.do";
      this.postJsonRequest(url, airline).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.$data.uploadSuccess = true;
          this.$data.showResult = true;
          if (!this.$data.currentAirline) {
            this.afterUploadAirline(oData.data);
          }
        } else if (oData.code != 401) {
          this.$data.uploadSuccess = false;
          this.$data.showResult = true;
        }
      });
    }, //当成功上传航线之后的回调函数
    afterUploadAirline(data) {
      const currentAirline = (this.$data.currentAirline = data);
      this.$data.local_id = currentAirline.local_id;
    },
    getAirlineObj(name) {
      const routeList = this.$data.routeList;
      const airline = {
        start_station_id: this.$data.starStayPointId,
        end_station_id: this.$data.endStayPointId,
        total_mileage: this.$data.totalLength,
        flihght_relative_altiude: this.$data.defaultHeight,
        average_altiude: this.$data.defaultHeight,
      };
      airline.task_coordinate_waypoints = "";
      let centerLon = 0;
      let centerLat = 0;
      //需要去除驻点坐标
      for (let index = 1; index < routeList.length; index++) {
        if (index == routeList.length - 1) {
          break;
        }
        const element = routeList[index];
        centerLon += element.lon;
        centerLat += element.lat;
        airline.task_coordinate_waypoints += index + ",";
        airline.task_coordinate_waypoints += element.lon + ",";
        airline.task_coordinate_waypoints += element.lat + ",";
        airline.task_coordinate_waypoints += element.rAlt + ",";
        airline.task_coordinate_waypoints += element.alt;
        if (index != routeList.length - 2) {
          airline.task_coordinate_waypoints += ";";
        }
      }
      airline.task_coordinate_points = airline.task_coordinate_waypoints;
      centerLon /= routeList.length;
      centerLat /= routeList.length;
      airline.center_lon = centerLon;
      airline.center_lat = centerLat;
      airline.name = name;
      //设置已上传航线的id
      if (this.$data.currentAirline) {
        airline.id = this.$data.currentAirline.id;
      }
      return airline;
    },
    blurInput(row, type) {
      if (this.isEmptyStr(row[type])) {
        row[type] = 0;
      }
      this.$refs.routePlanningEchart.renderChart(); //在修改高度后,重新绘制echart高度图
    },
  },
  mounted() {},
  beforeDestroy() {
    //清除定时
    if (this.$data.modifyPlayTimer) {
      clearTimeout(this.$data.modifyPlayTimer);
    }
    this.disposeMap();
  },
  watch: {
    routeList(nval, oval) {
      if (!this.isEmptyArray(nval)) {
        for (let index = 0; index < nval.length; index++) {
          const element = nval[index];
          element.index = index + 1;
        }
      }
    },
  },
  components: {
    MapStyle,
    RoutePlanningEchart,
    RoutePlanningPanel,
    RoutePlanningPlay,
    RoutePlanningReport,
    RoutePlanningResult,
    RoutePlanningNameSet,
    "tooltip-over": tooltipOver,
  },
};
</script>
<style scoped>
@import "../../../assets/css/mapCss/RoutePlanning.css";
</style>
<style>
/*隐藏ol的一些自带元素*/
#routePlanningMap .ol-attribution {
  display: none;
}
#routePlanningMap .ol-zoom {
  top: unset;
  left: unset;
  bottom: 7.5em;
  right: 0.5em;
  background: transparent;
}
#routePlanningMap .ol-control button {
  width: 24px;
  height: 24px;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
#routePlanningMap .ol-control button:hover,
#routePlanningMap .ol-control button:focus {
  background-color: #0083fd;
}
#routePlanningMap .ol-zoom .ol-zoom-out {
  margin-top: 4px;
}
#routePlanning .el-table--border::after,
#routePlanning .el-table--group::after,
#routePlanning .el-table::before {
  background-color: transparent !important;
}
#routePlanning .el-table__row > td {
  border: none;
}
#routePlanning .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(255, 255, 255, 0.1) !important;
  cursor: pointer;
}
#routePlanning .el-table__empty-text {
  font-size: 14px;
  font-family: AlibabaPuHuiTiR;
  font-weight: 400;
  color: #ffffff;
}
.routePlanning ::-webkit-scrollbar {
  width: 6px !important;
}
.routePlanning ::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
}
.routePlanning ::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}
.heightSetDialogContainer {
  margin-top: calc(25% - 70px) !important;
  background: rgba(28, 35, 64, 0) !important;
}
.heightSetDialogContainer .routePlanningSelect {
  float: left;
}
.heightSetDialogContainer .routePlanningSelect .el-input__inner {
  width: 104px;
  height: 30px;
  border: none;
  font-size: 14px;
  font-family: AlibabaPuHuiTiR;
  font-weight: 400;
  color: #ffffff;
  padding: 0 0;
  background: transparent !important;
}
.heightSetDialogContainer .routePlanningSelect .el-input__icon {
  line-height: 30px;
}
.heightSetDialogContainer .heightOptContainer .el-input {
  width: 70px;
  margin-left: 2px;
  margin-right: 2px;
  float: left;
}
.heightSetDialogContainer .heightOptContainer .el-input__inner {
  width: 70px;
  height: 30px;
  background: rgba(0, 131, 253, 0.1);
  border: 1px solid #146bf9;
  border-radius: 3px;
  font-size: 14px;
  font-family: ArialMT;
  font-weight: 400;
  color: #ffffff;
  padding: 0 0;
  text-align: center;
}
.heightSetDialogContainer .el-dialog__header {
  display: none !important;
}
.routePlanning .delBtn {
  font-size: 14px;
  font-family: AlibabaPuHuiTiR;
  font-weight: 400;
  color: #ffffff;
}
.routePlanning .delBtn:hover {
  color: #ffa63e !important;
}
.routePlanning .inputColumn input.el-input__inner {
  color: #ffffff !important;
  border: none !important;
  background: transparent !important;
  text-align: center;
  padding: 0px 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/taskplan/RoutePlanning.vue